import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { searchRoutes } from '../constants/routes';
import { logout } from '../redux/reducers/account/accountThunks';
import {
    selectIsAuthenticated,
    setIsAuthenticated,
} from '../redux/reducers/account/auth';
import TokenService from '../services/network/tokenService';
import { removeToken } from '../services/network/api';
import {
    clearAccountData,
    selectAccountId,
} from '../redux/reducers/account/account';
import { VEHICLE_TYPES } from '../constants/constTypes';

export const useNavbarData = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const accountId = useSelector(selectAccountId);
    const isAuthenticated = useSelector(selectIsAuthenticated);

    const navItems = [
        {
            id: 1,
            to: searchRoutes.CAR,
            text: t('cars'),
            icon: VEHICLE_TYPES.CAR,
        },
        {
            id: 2,
            to: searchRoutes.BIKE,
            text: t('bikes'),
            icon: VEHICLE_TYPES.BIKE,
        },
        {
            id: 3,
            to: searchRoutes.COMMERCIAL,
            text: t('commercials'),
            icon: VEHICLE_TYPES.COMMERCIAL,
        },
    ];

    const onLogoutClick = useCallback(() => {
        TokenService.clear();
        removeToken();
        dispatch(setIsAuthenticated(false));
        dispatch(clearAccountData());
        if (accountId) dispatch(logout(accountId));
        navigate('/');
    }, [accountId, dispatch, navigate]);

    return {
        navItems,
        onLogoutClick,
        isAuthenticated,
    };
};
